import { toast } from 'react-toastify';

import qs from 'querystring';
import { takeLatest, takeEvery, call, put, all, select } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestPleitoVeiculo({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'pleito/veiculo', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* deletePleitoVeiculo({ payload }) {
  try {
    const { idpleito, params } = payload;

    yield call(api.delete, `pleito/pleitoveiculo/${idpleito}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* store({ payload }) {
  try {
    const { pleito, params } = payload;

    yield call(api.post, 'pleito/veiculo', pleito);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/cadacom_pleitoveiculo');
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* find({ payload }) {
  try {
    const { idpleito } = payload;

    const { data } = yield call(api.get, `pleito/${idpleito}`);

    // data.param5usuariooperador = JSON.stringify(data.param5usuariooperador);
    // data.param7usuariooperador = JSON.stringify(data.param7usuariooperador);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* update({ payload }) {
  try {
    const { pleito, params } = payload;

    yield call(api.put, 'pleito/veiculo', pleito);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/cadacom_pleitoveiculo');
  } catch (erros) {
    console.log(erros)
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export function* applyedFilters({ payload }) {
  try {

    const { params } = payload

    const response = yield call(api.get, 'pleito/veiculo', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });


    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    console.log(erros)
    yield put(failedRequest());
    erros.map((error) => toast.error(error));
  }
}

export default all([
  takeLatest('@pleitoveiculo/PLEITOVEICULO_IN_REQUEST', requestPleitoVeiculo),
  takeLatest('@pleitoveiculo/DELETE_PLEITOVEICULO', deletePleitoVeiculo),
  takeLatest('@pleitoveiculo/SUCCESS_REMOVE', requestPleitoVeiculo),
  takeLatest('@pleitoveiculo/STORE_PLEITOVEICULO', store),
  takeLatest('@pleitoveiculo/FIND_PLEITOVEICULO', find),
  takeLatest('@pleitoveiculo/UPDATE_PLEITOVEICULO', update),
  takeLatest('@pleitoveiculo/RECORD_FILTERING', applyedFilters),
]);
